// extracted by mini-css-extract-plugin
export default {"slider":"applications-components-ProductsApp-components-CategorySidebar-category-sidebar-module__slider","bar":"applications-components-ProductsApp-components-CategorySidebar-category-sidebar-module__bar","barContent":"applications-components-ProductsApp-components-CategorySidebar-category-sidebar-module__barContent","title":"applications-components-ProductsApp-components-CategorySidebar-category-sidebar-module__title"};
    if(module.hot) {
      // 1791528099285
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  